/* Svensk katalog for locale-inbox-vouchers-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'inbox.inboxWithCount': 'Inkorg ({count})',
  'inbox.wordDocuments': 'dokument',
  'inbox.wordVouchers': 'verifikationer',
  'inbox.emptyDocsTitle': 'Inga dokument',
  'inbox.emptyTrashTitle': 'Papperskorgen är tom',
  'inbox.emptyDocsText': 'Ladda upp avtal, kontrakt och dokument här.',
  'inbox.searchDocsFull': 'Sök i dokument - filnamn, typ...',
  'inbox.vehicleCostReminderDefault': 'Endast om företaget äger eller leasar fordon.',
});
